
define(['jquery', 'core', 'app-common/component/ajax-call', 'common/location'], function($, core, ajaxCall, location) {
  return function(service, urlPart, type, data, dataFormat, timeout) {
    var rootUrl, url;
    if (dataFormat == null) {
      dataFormat = 'json';
    }
    rootUrl = (function() {
      switch (service) {
        case 'report':
          return location.reportingApiPath;
        case 'nodeway':
          return location.nodewayApiPath;
        case 'salesforce':
          return location.salesforceApiPath;
        case 'stripe':
          return location.stripeApiPath;
        case 'categorizer':
          return location.categorizerApiPath;
      }
    })();
    url = rootUrl + urlPart;
    return ajaxCall(url, type, data, dataFormat, true, timeout);
  };
});
